module.exports = __webpack_public_path__ + "static/jason-lipps-coastal-advisory-group-079b56ee5243a5fe5df908ec11143a20.png";